module.exports = __webpack_public_path__ + "static/blog-d395070cf8378e7a152ca16c72735cce.png";